import axios from 'axios';
import { API_BASE } from './config';
import { AdminUser } from '../types/models';

export async function getUsers(): Promise<AdminUser[]> {
  const response = await axios.get<AdminUser[]>(`${API_BASE}/users`);
  return response.data;
}
